<template>
  <div class='ToiletIcon'>
    <svg fill="#000000" width="22px" height="22px" viewBox="-16.84 0 122.88 122.88" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  style="enable-background:new 0 0 89.19 122.88" xml:space="preserve">
      <g>
        <path class="st0" d="M10.37,84.59C4.17,79.12,0.46,71.46,0,60.91h89.19c-0.33,9.94-2.94,17.23-8.18,21.45 c-5.25,4.23-14.02,4.67-20.88,7.81c-1.49,0.68-2.87,1.52-4.12,2.56c-7.58,6.3-5.38,15.5,1.61,21.31v8.84H10.6v-15.91H2.71V94.84 h7.66V84.59L10.37,84.59z M0.03,54.56V0c6.73,0,13.47,0,20.2,0l6.95,54.56H0.03L0.03,54.56z M31.38,48.73h57.71v5.83H31.38V48.73 L31.38,48.73z"/>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ToiletIcon'
}
</script>

<style scoped>
.ToiletIcon {
  cursor: pointer;
}
</style>
